export default "__VITE_ASSET__15ce138d__"